import {
  CardHeader as CardHeaderMui,
  CardHeaderProps as CardHeaderPropsMui,
} from '@mui/material';

export type CardHeaderProps = Pick<CardHeaderPropsMui, 'action' | 'title'>;

export function CardHeader({ ...rest }: CardHeaderProps) {
  return <CardHeaderMui {...rest} />;
}
